<template>
    <label class="col-xl-3 col-lg-3 col-form-label">
        <slot></slot>
        <span v-if="required" class="mandatory">&nbsp;*</span>
    </label>
</template>

<script setup lang="ts">
    defineProps<{
        required?: boolean;
    }>();
</script>
